const messages = {
  addEmails: 'Add email addresses one per line or separated by commas',
  addMessage: 'Add message here',
  buyerEmail: 'Buyer Email',
  copyRecipients: 'Copy recipient(s) on email',
  emailSettings: 'Email Settings',
  excludeTerms: 'Exclude "Terms & Conditions" from PDFs',
  excludeImages: 'Exclude images from PDFs',
  failedResend: 'Your emails failed to send.',
  invalidEmails: (emails, emailCount) => {
    const message =
      emailCount === 1
        ? 'is not a valid email address'
        : 'are not valid email address'
    return (
      <span>
        <var>{emails}</var> {message}
      </span>
    )
  },
  maxCharError: (maxLength) => (
    <span>
      Copy recipients field must not exceed <var>{maxLength}</var> characters
    </span>
  ),
  mergeOrders: 'Merge orders into one PDF file',
  personalizedMessage: 'Add personalized message (optional)',
  poNumber: 'PO#',
  resendEmails: 'Resend Emails',
  resendTo: 'Resend emails to',
  retailer: 'Retailer',
  sendEmails: 'Send Emails',
  successfulResend: 'Your emails have been sent.',
  zip: 'ZIP PDFs',
}

export default messages
